import React, { useCallback, useState } from 'react';
import { MESSAGE_ACTIONS } from '../Message/utils';
import { useTranslationContext } from '../../context/TranslationContext';
var UnMemoizedMessageActionsBox = function (props) {
    var getMessageActions = props.getMessageActions, handleDelete = props.handleDelete, handleEdit = props.handleEdit, handleFlag = props.handleFlag, handleMute = props.handleMute, handlePin = props.handlePin, isUserMuted = props.isUserMuted, message = props.message, messageListRect = props.messageListRect, mine = props.mine, _a = props.open, open = _a === void 0 ? false : _a;
    var t = useTranslationContext().t;
    var _b = useState(false), reverse = _b[0], setReverse = _b[1];
    var messageActions = getMessageActions();
    var checkIfReverse = useCallback(function (containerElement) {
        if (!containerElement) {
            setReverse(false);
            return;
        }
        if (open) {
            var containerRect = containerElement.getBoundingClientRect();
            if (mine) {
                setReverse(!!messageListRect && containerRect.left < messageListRect.left);
            }
            else {
                setReverse(!!messageListRect && containerRect.right + 5 > messageListRect.right);
            }
        }
    }, [messageListRect, mine, open]);
    return (React.createElement("div", { className: "str-chat__message-actions-box\n        " + (open ? 'str-chat__message-actions-box--open' : '') + "\n        " + (mine ? 'str-chat__message-actions-box--mine' : '') + "\n        " + (reverse ? 'str-chat__message-actions-box--reverse' : '') + "\n      ", "data-testid": 'message-actions-box', ref: checkIfReverse },
        React.createElement("ul", { className: 'str-chat__message-actions-list' },
            messageActions.indexOf(MESSAGE_ACTIONS.pin) > -1 && !(message === null || message === void 0 ? void 0 : message.parent_id) && (React.createElement("button", { onClick: handlePin },
                React.createElement("li", { className: 'str-chat__message-actions-list-item' }, !(message === null || message === void 0 ? void 0 : message.pinned) ? t('Pin') : t('Unpin')))),
            messageActions.indexOf(MESSAGE_ACTIONS.flag) > -1 && (React.createElement("button", { onClick: handleFlag },
                React.createElement("li", { className: 'str-chat__message-actions-list-item' }, t('Flag')))),
            messageActions.indexOf(MESSAGE_ACTIONS.mute) > -1 && (React.createElement("button", { onClick: handleMute },
                React.createElement("li", { className: 'str-chat__message-actions-list-item' }, isUserMuted && isUserMuted() ? t('Unmute') : t('Mute')))),
            messageActions.indexOf(MESSAGE_ACTIONS.edit) > -1 && (React.createElement("button", { onClick: handleEdit },
                React.createElement("li", { className: 'str-chat__message-actions-list-item' }, t('Edit Message')))),
            messageActions.indexOf(MESSAGE_ACTIONS.delete) > -1 && (React.createElement("button", { onClick: handleDelete },
                React.createElement("li", { className: 'str-chat__message-actions-list-item' }, t('Delete')))))));
};
/**
 * MessageActionsBox - Allows a user to edit, flag or delete a message.
 * @example ./MessageActionsBox.md
 */
export var MessageActionsBox = React.memo(UnMemoizedMessageActionsBox);
